/*
This is just for queing up betlinks that are clicked on before the
Fresh8 Integrated betslip is available.

Only relevant for feature "integrated-betslip"
*/

export const STORE = 'common/betlinks/STORE';
export const CLEAR = 'common/betlinks/CLEAR';
export const ADD = 'common/betlinks/ADD';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case STORE:
      return {
        ...state,
        queue: [...(state.queue || []), action.data]
      };
    case CLEAR:
      return {
        ...state,
        queue: []
      };
    default:
      return state;
  }
}

export function getQueuedBetLinks(globalState) {
  return globalState.common.betlink.queue;
}

export function queueBetLink(data) {
  return {
    type: STORE,
    data
  };
}

export function clearBetLinks() {
  return {
    type: CLEAR
  };
}

export function addBet(data) {
  return {
    type: ADD,
    data
  };
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/betlink.js